import type { NavigateFn } from "@tanstack/react-router";
import { v4 as uuidv4 } from "uuid";
import { getErrorMessage } from "./api-client";

export interface InitialRegenerateParams {
  prompt: string;
  sessionId: string;
  uploadedFiles: (File | null)[] | null | undefined;
  referenceImagePreviews: string[] | null | undefined;
  referenceAssetIds?: (string | null)[] | null;
  navigate: NavigateFn;
  setSelectedImageIndex: (i: number | null) => void;
  setIsRegenerating: (v: boolean) => void;
}

export async function runInitialRegenerate({
  prompt,
  sessionId,
  uploadedFiles,
  referenceImagePreviews,
  referenceAssetIds,
  navigate,
  setSelectedImageIndex,
  setIsRegenerating,
}: InitialRegenerateParams): Promise<void> {
  if (!prompt.trim()) {
    alert("Please enter a prompt");
    return;
  }
  if (!sessionId) {
    alert("Session ID is required");
    return;
  }
  setSelectedImageIndex(null);
  setIsRegenerating(true);
  try {
    navigate({
      to: "/results",
      search: {
        sessionId,
        prompt: prompt.trim(),
        requestId: uuidv4(),
      },
      state: {
        uploadedFiles: uploadedFiles ?? undefined,
        referenceImagePreviews: referenceImagePreviews ?? undefined,
        referenceAssetIds: referenceAssetIds ?? undefined,
      },
      replace: false,
    });
    setIsRegenerating(false);
  } catch (err) {
    alert(getErrorMessage(err));
    setIsRegenerating(false);
  }
}
